import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Modal from '@material-ui/core/Modal';
import '../App.css';
import '../popup.css';

const useStyles = makeStyles((theme) => ({
    paper: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontFamily: 'WorkSans',
        position: 'absolute',
        maxWidth: '95vw',
        maxHeight: '90vh',
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

export default function ModalS(props) {
    const classes = useStyles();

    const body = (
        <div className={classes.paper}>
            <div id="simple-modal-title">{props.popupTitle}</div>
            <div id="simple-modal-description">{props.popupBody}</div>
        </div>
    );

    return (
        <div>
            <Modal
                open={props.openM}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
